import SessionManagerRecord, { SessionManagerRecordSource } from '../lib/SessionManagerRecord.js';
/**
 */
class ApplicationToken extends SessionManagerRecord {
}
ApplicationToken.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
    options: {
        primaryKeyPropertyName: 'key',
    },
};
export default ApplicationToken;
